/*

    Function that can be called from external Node.js scripts as well, not only from SvelteKit server

*/
export const rareness_thresholds = [0,  0.1,         0.2,    0.3,         0.5,    0.65,       0.85];
export const rareness_levels =     ['', 'Legendary', 'Epic', 'Very rare', 'Rare', 'Uncommon', 'Common', 'Very Common'];
export const rareness_colors =     ['', 'var(--legendary-color)', '#bf9b30', '#a0a0a0', '#000FF00', '#000FF00', '#000FF00', '#000FF00'];

export const PURGE_DAYS = 15;


export function is_whole(x) {
    return (typeof x === 'string' && /^(0+|[1-9]\d*)$/.test(x)) || (Number.isInteger(x) && x >= 0);
}


export function is_natural(x) {
    //return typeof x === 'string' ? x.match(/^\d+$/i) : false;
    //return typeof x === 'string' ? /^\d+$/i.test(x) : false;
    return (typeof x === 'string' && /^[1-9]\d*$/.test(x)) || (Number.isInteger(x) && x >= 1);
}


export function is_email(x) {
    //return typeof x === 'string' ? x.match(/^\s*[a-z0-9!#$%&'*+\/=?^_‘{|}~-]+(\.[a-z0-9!#$%&'*+\/=?^_‘{|}~-]+)*@([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z0-9][a-z0-9-]*[a-z0-9]\s*$/i) : false;
    return typeof x === 'string' ? /^\s*[a-z0-9!#$%&'*+\/=?^_‘{|}~-]+(\.[a-z0-9!#$%&'*+\/=?^_‘{|}~-]+)*@([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z0-9][a-z0-9-]*[a-z0-9]\s*$/i.test(x) : false;
}


export function is_username(x) {
    //return typeof x === 'string' ? x.match(/^\s*[a-z0-9._~-]+\s*$/i) : false;
    return typeof x === 'string' ? /^\s*[a-z0-9._~-]+\s*$/i.test(x) : false;
}


// Adds https:// to an url if it doesn't start already with protocol:// or mailto:
export function normalize_url(url) {
    if(typeof url !== 'string') return undefined;
    return url.match(/^(\w+?:\/\/|mailto:)/) ? url : is_email(url) ? `mailto:${url}` : `https://${url}`;
}

export function normalize_string(s) {
    if (typeof s !== 'string') return undefined;

    // 1. Decompose combined characters (NFD)
    let normalized = s.normalize("NFD");

    // 2. Remove diacritics (combining marks)
    normalized = normalized.replace(/\p{M}/gu, "");

    // 3. Replace any non-letter/number with a single space
    normalized = normalized.replace(/[^\p{L}\p{N}]+/gu, " ");

    // 4. Collapse multiple spaces, lowercase, trim
    normalized = normalized.replace(/\s+/g, " ").toLowerCase().trim();

    return normalized;
}

export function is_uuid(str) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(str);
}


/*
        $username = trim($PARAM["username"]);
        if(mb_strlen($username) < 3) $report_back = "Username must be at least 3 characters long";
        else if(mb_strlen($username) > 16) $report_back = "Username must be at maximum 16 characters long";
        else if(!preg_match(USERNAME_RE, $username)) $report_back = "Username only allows latin letters, digits or symbols -._~";
        else if(preg_match("/^\s*[._~-]+\s*$/i", $username)) $report_back = "Username must contain something but symbols";
        else if(preg_match("/^\s*\d+\s*$/i", $username)) $report_back = "Username must contain something but digits";
        else // DB check
*/
export function username_errors(username) {
    let report_back = null;
    if (username) {
        username = username.trim();
        if(username.length < 3) report_back = "Username must be at least 3 characters long";
        else if(username.length > 16) report_back = "Username must be at maximum 16 characters long";
        else if(!is_username(username)) report_back = "Username only allows latin letters, digits or symbols -._~";
        else if(/^[._~-]+$/i.test(username)) report_back = "Username must contain something but symbols";
        else if(/^\d+$/i.test(username)) report_back = "Username must contain something but digits";
        else if(['admin', 'been', 'beeneverywhere', 'undefined', 'null',
            'false', 'true', 'nan', 'username', 'name', 'user']
                .includes(username.toLowerCase())) report_back = "This username is not available";
        // No database check here because the same Fn used on the front and on the back:
        //else if(!await db_is_username_free(username)) report_back = "This username is already in use";
        else
            report_back = null; // Usernamme is ok;
    } else {
        report_back = "Username must not be empty";
    }
    return report_back;
}


export function htmlspecialchars(str) {
    if(!str) {
        return "";
    } else if (typeof str !== 'string') {
        throw new TypeError('Expected a string');
    }

    const replacements = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    };

    return str.replace(/[&<>"']/g, function(m) {
        return replacements[m];
    });
}


export function achievements_from_stats(stats) {
    if(stats?.rare_tcc) {
        return (stats.rare_tcc?.['1'] ? 4 : 0)
             + (stats.rare_tcc?.['2'] ? 2 : 0)
             + (stats.rare_tcc?.['3'] ? 1 : 0);
    } else {
        return 0;
    }
}

// Compare atomic values with ===
export function jsonDeepStrictEqual(obj1, obj2) {
    // Check if both arguments are objects
    if (obj1 && obj2 && typeof obj1 === 'object' && typeof obj2 === 'object') {
        // Get the keys of both objects
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        // Check if the number of keys is the same
        if (keys1.length !== keys2.length) {
            return false;
        }

        // Recursively compare each key-value pair
        for (let key of keys1) {
            if (!jsonDeepStrictEqual(obj1[key], obj2[key])) {
                return false;
            }
        }

        // If all key-value pairs match, return true
        return true;
    } else {
        // Compare non-object values directly
        return obj1 === obj2;
    }
}


// Compare atomic values with ==
export function jsonDeepEqual(obj1, obj2) {
    if (obj1 === obj2) return true; // Same reference

    if (
      typeof obj1 !== 'object' || obj1 === null ||
      typeof obj2 !== 'object' || obj2 === null
    ) {
      return obj1 == obj2; // Compare atomic values with ==
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) return false; // Different number of keys

    return keys1.every(key =>
        obj2.hasOwnProperty(key) && jsonDeepEqual(obj1[key], obj2[key])
    );
}


/*
            const un = visitedCnt(stats?.un);
            const unp = visitedCnt(stats?.unp);
            const tcc = visitedCnt(stats?.tcc);
            const reg = visitedCnt(stats?.reg);
*/            
// {"AO": 1, "FR": 2, "GB": 1, "MN": 1, "RU": 3, "US": 1, "ZM": 1}  --> 7
export function visitedCnt(visited) { 
    return (typeof visited === 'object' && visited !== null) ? Object.keys(visited).length : 0;
}


// osm_uid is our internal name of First Letter of osm_type + osm_id. 
// Example: R7619051 = osm_type first letter (one of node(N), way(W) or relation(R)) + osm_id 7619051 
export function is_osm_uid(osm_uid) {
    return /^[NWR]\d+$/i.test(osm_uid);
}


export function parse_osm_uid(osm_uid) {
    if(is_osm_uid(osm_uid)) {
        return { 
            osm_type:   osm_uid.charAt(0).toUpperCase(), //osm_uid[0].toUpperCase(),
            osm_id:     Number(osm_uid.slice(1)) 
        };
    } else {
        return {};
    }
}

export function formatUTCDate(date, short = false) {
    if(is_natural(date)) {
        date = new Date(date * 1000);
    }
    if(!(date instanceof Date)) {
        return date;
    }
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');
    return short ? `${year}-${month}-${day}` : `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}


export function csvQuoteIfNeeded(str) {
    if(/[",\n\r]/.test(str) && !/^\s/.test(str)) {
        // If the string needs to be quoted, add double quotes and escape existing double quotes
        return '"' + str.replace(/"/g, '""') + '"';
    }
    // If the string is valid, return it as is
    return str;
}


// Equivalent to PHP's sleep function
export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}


export function randomPassword(pwdlen = 8) {
    let alphabet =   'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890~`!@#$%^&*()_-+={[}]|:;"<,>.?/\\';
    let pass = [];
    let alphaLength = alphabet.length - 1;
    for (let i = 0; i < pwdlen; i++) {
        let n = Math.floor(Math.random() * (alphaLength + 1));
        pass.push(alphabet.charAt(n));
    }
    return pass.join('');
}


export function short_country_name(country_name) {
    switch(country_name) {
        case 'Russian Federation':
            country_name = 'Russia';
            break;
        case 'United Kingdom':
            country_name = 'UK';
            break;
        case 'United Arab Emirates':
            country_name = 'UAE';
            break;
        case 'United States':
        case 'United States of America':
            country_name = 'USA';
            break;
        case 'Bosnia and Herzegovina':
            country_name = 'Bosnia';
            break;
        default:
            break;
    }
    return country_name;
}


export function get_json_timestamp(json) {
    if (Array.isArray(json) && json.length > 0 && json[0].timestamp) {
        return json[0].timestamp;
    } else if (json && typeof json === 'object' && json.timestamp) {
        return json.timestamp;
    } else {
        return undefined; // timestamp not found
    }
}


export function relative_time(timestamp) {
    let difference = Math.floor(Date.now() / 1000) - Number(timestamp);
    let ending;

    const periods    = ["sec", "min", "hour", "day", "week", "month", "year"];
    const lengths    = [60, 60, 24, 7, 4.35, 12];

    if (difference >= 0) { // this was in the past
        ending = " ago";
    } else { // this was in the future
        difference = -difference;
        ending = ''; // " to go";
    }
    if (difference < 30)
        return "Just now";
    let j = 0;
    for (; (lengths[j] ?? false) && difference >= lengths[j]; j++) {
        difference /= lengths[j];
    }
    difference = Math.round(difference);
    if(difference != 1)
        periods[j] += "s";
    return `${difference} ${periods[j]}${ending}`;
}


export function deterministicStringify(obj) {
    if (Array.isArray(obj)) {
        return `[${obj.map(deterministicStringify).join(',')}]`;
    } else if (obj && typeof obj === 'object') {
        const keys = Object.keys(obj).sort();
        return `{${keys.map(key => `${JSON.stringify(key)}:${deterministicStringify(obj[key])}`).join(',')}}`;
    } else {
        return JSON.stringify(obj);
    }
}